import { render, staticRenderFns } from "./PagesLatestProductsWidget.vue?vue&type=template&id=e4ac15e4&"
import script from "./PagesLatestProductsWidget.vue?vue&type=script&lang=js&"
export * from "./PagesLatestProductsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports